import React from 'react'

export default function Footer() {
    return (
        <footer>
            <p>copyright &copy; 2020 Roberto Castelli</p>
            <p>www.robertocastelli.dev</p>
        </footer>
    )
}
